import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { VoucherAllocationResultDto } from '../services/api.service';
import { navigateWithSlide, SlideDirection } from '../transitions/route-transition-direction.service';
import { Router } from '@angular/router';
import { RouteTypeService } from '../services/route-type.service';
@Component({
  selector: 'cert-voucher-allocation-results',
  standalone: false,
  templateUrl: './voucher-allocation-results.component.html',
  styles: ``,
})
export class VoucherAllocationResultsComponent implements OnInit {
  @Input() allocations: VoucherAllocationResultDto[] = [];
  @Output() view = new EventEmitter<number>();

  portalSegment!: string;

  constructor(
    private readonly router: Router,
    private readonly routeTypeService: RouteTypeService,
  ) {}

  ngOnInit() {
    this.portalSegment = this.routeTypeService.getPortalSegment();
  }

  onSelect(allocationId: number) {
    this.view.emit(allocationId);
  }

  getAllocatedPct(voucherAllocation: VoucherAllocationResultDto): number {
    return voucherAllocation.allocatedAmount > 0
      ? Math.min(100, (voucherAllocation.creditsIssuedAmount / voucherAllocation.allocatedAmount) * 100)
      : 0;
  }

  getRedeemedPct(voucherAllocation: VoucherAllocationResultDto): number {
    return voucherAllocation.allocatedAmount > 0
      ? Math.min(100, (voucherAllocation.redeemedAmount / voucherAllocation.allocatedAmount) * 100)
      : 0;
  }

  onViewAllocation(voucherAllocationId: number) {
    navigateWithSlide(this.router, [`${this.portalSegment}/vouchers/${voucherAllocationId}`], SlideDirection.Right);
  }
}
